import chalk from "chalk"

import { CHAPERON_API_URL } from "../const/paths"
import { consoleLog } from "../utilities/helpers"
import {
    fetchAddress,
    fetchCountry,
    fetchNeighborhood,
} from "./googleMapsConnector"
import { getEntitiesData } from "./chaperonConnector"

export const searchPlaces = async (input) => {
    try {
        const token = localStorage.getItem("chaperon_auth_token")
        const response = await fetch(
            `${CHAPERON_API_URL}/v1/places/autocomplete`,
            {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ input }),
            }
        )
        return await response.json()
    } catch (error) {
        console.error("Error fetching places:", error)
        return []
    }
}

export const getPlaceDetails = async (placeId) => {
    consoleLog(
        `Fetching place details for ${placeId} from ${chalk.red(
            `Chaperon API`
        )}.`
    )
    try {
        const token = localStorage.getItem("chaperon_auth_token")
        const response = await fetch(`${CHAPERON_API_URL}/v1/places/details`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ placeId }),
        })
        let placeDetails = await response.json()
        placeDetails.photo_cover = await getPlacePhoto(placeId)
        return await placeDetails
    } catch (error) {
        console.error("Error fetching place details:", error)
        return null
    }
}

export const getPlacePhoto = async (placeId) => {
    consoleLog(
        `Fetching place photo for ${placeId} from ${chalk.red(`Chaperon API`)}.`
    )
    try {
        const token = localStorage.getItem("chaperon_auth_token")
        const response = await fetch(
            `${CHAPERON_API_URL}/v1/places/get/photoref?placeId=${placeId}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        return await response.json()
    } catch (error) {
        console.error("Error fetching place details:", error)
        return null
    }
}

export async function getLocationPlace(location) {
    if (!location.coordinates.latitude || !location.coordinates.longitude) {
        consoleLog("No coordinates available.")
        return null
    }

    try {
        const addressComponents = await fetchAddress(location)

        let neighborhoodArray = await fetchNeighborhood(addressComponents)
        let neighborhood = neighborhoodArray.join(", ")

        let country = await fetchCountry(addressComponents)
        let neighborhoods = await searchPlaces(neighborhood)

        let placeDetails = await getPlaceDetails(neighborhoods[0].place_id)

        let neighborhoodPlaces = await getEntitiesData(
            placeDetails.name,
            country,
            placeDetails.formatted_address
        )
        let neighborhoodPlace = neighborhoodPlaces[0]

        // TODO: Check for accuracy of match (e.g. proximity, country, population, etc.)
        neighborhoodPlace.fromGoogle = placeDetails

        return neighborhoodPlace
    } catch (error) {
        console.error("Error fetching place for location:", error)
        return null
    }
}
